var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 637.27 637.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e50000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m251.28,430.89l67.35-67.36,67.36,67.36c12.4,12.4,32.5,12.4,44.9,0h0c12.4-12.4,12.4-32.5,0-44.9l-67.36-67.36,67.36-67.35c12.4-12.4,12.4-32.5,0-44.9h0c-12.4-12.4-32.5-12.4-44.9,0l-67.35,67.35-67.35-67.35c-12.4-12.4-32.5-12.4-44.9,0h0c-12.4,12.4-12.4,32.5,0,44.9l67.35,67.35-67.35,67.35c-12.4,12.4-12.4,32.5,0,44.9h0c12.4,12.4,32.5,12.4,44.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.25,637.27c176,.21,319.22-143.02,319.02-319.02C637.06,143.14,494.13.2,319.01,0,143.02-.2-.2,143.02,0,319.01c.2,175.12,143.14,318.05,318.25,318.26Zm-3.18-573.52c143.36-1.97,260.41,115.08,258.44,258.44-1.89,137.49-113.84,249.44-251.32,251.32-143.36,1.97-260.41-115.08-258.44-258.44,1.89-137.49,113.84-249.44,251.32-251.32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed);
export default __webpack_public_path__ + "static/media/red.81150dd1061e90cc3fbc391989e60657.svg";
export { ForwardRef as ReactComponent };